import { Box, Modal, TextField } from '@mui/material'
import React, { useState } from 'react'
import { isEmpty, showToast, validateEmail } from '../../utils/AppHelper'
import { TextBold, TextRegular } from '../../commonComponents/TextStyling'
import AppButton from '../../commonComponents/AppButton'
import serverData from '../../api/ServerData'
import { ENV } from '../../ENV'
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 5,
  p: 2,
  width: {
    xs: '90%',
    sm: '50%'
  }
}

export default function ForgotPasswordModal ({ onClose }) {
  const [forgotEmail, setForgotEmail] = useState('')
  const [formError, setFormError] = useState({})
  const [loading, setLoading] = useState(false)

  function emailVerify (event) {
    event.preventDefault()
    const error = {}
    if (isEmpty(forgotEmail)) {
      error.forgotEmail = 'Please enter your registered email.'
    } else if (!validateEmail(forgotEmail)) {
      error.forgotEmail = 'Please enter a valid email id.'
    } else {
      setLoading(true)
      serverData.forgotPassword(
        { email: forgotEmail },
        result => {
          if (result.status) {
            onClose(result.message)
          } else {
            showToast(result.message)
          }
          setLoading(false)
        },
        error => {
          setLoading(false)
          showToast(error?.statusText)
        }
      )
    }
    setFormError(error)
  }
  return (
    <Modal open={true}>
      <Box sx={style}>
        <Box component='form' onSubmit={emailVerify} noValidate>
          <TextBold align='center' style={{ fontSize: 22 }}>
            Reset password
          </TextBold>
          <br />

          <TextRegular style={{ whiteSpace: 'pre-line' }}>
            Type the email address you used to create your {ENV.product_name}{' '}
            account.
          </TextRegular>
          <br />
          <TextRegular style={{ whiteSpace: 'pre-line' }}>
            We will email you a link to reset your password.
          </TextRegular>
          <TextField
            margin='normal'
            required
            fullWidth
            name='forgotEmail'
            label='Enter your email'
            type='forgotEmail'
            id='forgotEmail'
            value={forgotEmail}
            onChange={event => {
              var { value } = event.target
              if (value.length < 50) {
                setForgotEmail(value)
              }
            }}
            error={formError.forgotEmail}
            helperText={formError.forgotEmail}
          />
        </Box>

        <AppButton
          loading={loading}
          fullWidth={false}
          type='submit'
          name={'Submit'}
          style={{
            height: '50px',
            marginRight: '15px',
            marginTop: '20px'
          }}
          onClick={emailVerify}
        />

        <AppButton
          disabled={loading}
          variant='outlined'
          fullWidth={false}
          name={'Cancel'}
          sx={{ mt: 55, mb: 2 }}
          style={{ height: '50px', marginTop: '20px' }}
          onClick={() => onClose()}
        />
      </Box>
    </Modal>
  )
}
